import React from 'react'
function ApplicationSubmitted (props){

    return(
    <>
      	<div className="bayan-steps-wrapper ">
          <div className="begin-screen">
            <div 
            className="body-content text-align-center"
            >
                <br />
                <br />
                <br />
                <h3><b>Thank you for submitting your</b></h3>
                <h3><b>Application for Admission to Bayan!</b></h3>
                <br />
                <p>We will begin reviewing your application as soon as possible</p>
                <p>and will be in touch soon.</p>
                <br />
                <p>If you have any questions, please feel free to contact us at</p>
                <p>714-862-2926 or <a href="mailto:admissions@bayanonline.org">admissions@bayanonline.org</a></p>
                <br />
                <br />
                <br />
            </div>
          </div>
        </div>
    </>
    );
  }

export default ApplicationSubmitted;
